<script>
  import { afterUpdate } from 'svelte';
  export let link_id = null;
  export let link;
  export let visible_favicon = true;
  export let visible_meta = true;
  export let visible_star = true;
  export let elipsis = false;
  import request from 'superagent';
  
  let domain, favicon;
  
  afterUpdate(() => {
    domain = parseDomain();
    favicon = prepareFavicon();
  });
  
  function parseDomain() {
    let r = link.uri.match(/^(\w+:\/\/)?(.[^/]+)/);
    if (r === null || r.length < 3) return "";
    const wwwr = /^www\./i;
    return r[2].replace(wwwr, "");
  }
  
  function prepareFavicon() {
    if (!domain.length) return "";
    return `https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://${domain}&size=16`;
    //return "http://www.google.com/s2/favicons?domain=" + domain;
  }
  
  function like() {
    request.post(`/rate/link/${link.id}.jsr`)
      .then(resp => {
        if (resp.statusCode == 200)
          link.rating++;
        else if (resp.statusCode == 204)
          link.rating--;
      })
      .catch(resp => {
        console.log("Error when LIKING")
        console.log(JSON.stringify(resp))
      });
  }
</script>
<div class='row mb-2'>
<div class='col-12'>
<h6 class='mb-0 pl-1'>
{#if visible_favicon}
<a class:elipsis2='{elipsis}' href='{link.uri}' target='_blank'>
{link.title}
</a>
{:else}
<a class:elipsis2='{elipsis}' class='pl-4' href='{link.uri}' target='_blank'>
{link.title}
</a>
{/if}
</h6>
<div class='w-100'></div>
{#if visible_meta}
<div class='meta text-muted pl-1'>
<span class='pl-4 badge badge-light' style='background: url({favicon}) left center no-repeat'>
{domain}
</span>
{#if link.language && link.language != 'cz'}
<span class='badge badge-light badge-lg'>
{link.language}
</span>
{/if}
{#if visible_star}
<small class='badge text-muted pntr' on:click='{() => like()}'>
<i class='fa fa-star'></i>
</small>
{/if}
</div>
{/if}
</div>
</div>

